module.exports = __webpack_public_path__ + "img/person.0f53adfc.png";